import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommitteeItemsModule } from '../committee-items/committee-items.module';
import { CommitteeConditionsComponent } from './committee-conditions.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  declarations: [CommitteeConditionsComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatTableModule,
    MatButtonModule,
    MatSelectModule,
    MatCardModule,
    CommitteeItemsModule,
  ],
  exports: [CommitteeConditionsComponent],
})
export class CommitteeConditionsModule {}
